import { useState } from 'react';
import { useCarrito } from '../../hooks/useCarrito';
import { useCrearPedido } from '../../hooks/useCheckout';
import { ContactForm } from '../../components/public/ContactForm';
import { Spinner } from '../../components/shared/Spinner';
import { InfoIcon } from '../../components/shared/icons';
import { useToast } from '../../components/shared/Toast';

export function CheckoutPage() {
  const { data: carrito, isLoading } = useCarrito();
  const crearPedido = useCrearPedido();
  const { mostrarError } = useToast();
  const [enlaceRespaldo, setEnlaceRespaldo] = useState<string | null>(null);

  if (isLoading) return <Spinner />;

  const confirmar = (contacto: { nombre: string; telefono: string }) => {
    crearPedido.mutate(contacto, {
      onSuccess: (respuesta) => {
        // NFR Design: si la redireccion automatica falla (ej. bloqueador de
        // pop-ups), se deja el enlace visible como respaldo (RESILIENCY-10).
        setEnlaceRespaldo(respuesta.enlaceWhatsApp);
        window.location.href = respuesta.enlaceWhatsApp;
      },
      onError: (error) => mostrarError((error as Error).message),
    });
  };

  return (
    <section className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-14 py-8 md:py-12 flex flex-col md:flex-row gap-8 md:gap-12 md:justify-center">
      <div className="w-full md:flex-1 md:max-w-[420px] flex flex-col gap-5 bg-surface border border-border rounded-xl p-6 md:p-7 h-fit">
        <h2 className="text-xl font-display font-semibold text-[oklch(28%_0.03_50)]">
          Resumen de tu pedido
        </h2>
        <div className="flex flex-col gap-3.5">
          {(carrito?.lineas ?? []).map((linea) => (
            <div key={linea.id} className="flex justify-between text-[13px]">
              <span>Producto × {linea.cantidadDePaquetes}</span>
              <span className="font-semibold">S/ {linea.subtotal.toFixed(2)}</span>
            </div>
          ))}
        </div>
        <div className="border-t border-border pt-3.5 flex justify-between text-lg font-bold">
          <span>Total</span>
          <span>S/ {(carrito?.total ?? 0).toFixed(2)}</span>
        </div>
      </div>

      <div className="w-full md:flex-1 md:max-w-[420px] flex flex-col gap-6">
        <div className="flex flex-col gap-1.5">
          <h1 className="text-[28px] font-display font-semibold text-[oklch(28%_0.03_50)]">
            Un último paso
          </h1>
          <p className="text-[13px] leading-relaxed text-ink-muted">
            Déjanos tus datos de contacto. Te redirigiremos a WhatsApp con el resumen de tu pedido
            listo para coordinar el pago y la entrega.
          </p>
        </div>

        <ContactForm onSubmit={confirmar} enviando={crearPedido.isPending} />

        {enlaceRespaldo && (
          <a href={enlaceRespaldo} className="text-sm font-semibold text-terracotta underline">
            ¿No se abrió WhatsApp automáticamente? Haz clic aquí.
          </a>
        )}

        <div className="flex items-start gap-2.5 p-3.5 bg-[oklch(94%_0.02_70)] rounded-lg">
          <InfoIcon width={15} height={15} className="text-ink-muted mt-0.5 shrink-0" />
          <p className="text-xs leading-relaxed text-ink-muted">
            Aceptamos transferencia bancaria, Yape, Plin o efectivo contra entrega. Coordinamos todo
            por WhatsApp una vez recibamos tu pedido.
          </p>
        </div>
      </div>
    </section>
  );
}
